<template>
 <div class="projects-page-nav-bar">
   <img src="../assets/icons/vitech-logo01.png" alt="">
   <div class="links-container">
     <router-link class="navbar-link" to="/landing-page" >OUR PRODUCTS</router-link>
     <router-link class="navbar-link" to="" >OUR PROJECTS</router-link>
     <router-link class="navbar-link" to="" >CONTACT US</router-link>
   </div>

 </div>
</template>

<script>
 export default {
  name: 'ProjectsPageNavBar',

 }
</script>

<style lang="scss">
@import "ProjectsPageNavBar.scss";
</style>
